import { useContext, useMemo } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { ModalProps } from '@wix/da-ds/pkg/modals/dsPresets/Modal';

export default function useModalDefaults() {
  const isMobile = useContext(MobileContext);

  return useMemo(
    () =>
      ({
        isOpen: true,
        useFixedMobileHeight: true,
        isFullscreen: isMobile,
        ignoreClickOutside: true,
        showFooterBorder: true,
        showHeaderBorder: true,
      }) as ModalProps,
    [isMobile]
  );
}
